import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { useOpenPanelStore } from "@/stores/openPanelStore";
import { useAuthStore } from "@/stores/authStore";
import { maskSensitivePathData } from "@/lib/analytics";

export function OpenPanelTracker() {
  const location = useLocation();
  const screenView = useOpenPanelStore((state) => state.screenView);
  const status = useAuthStore((state) => state.status);

  useEffect(() => {
    // Отправляем события только для авторизованных пользователей
    if (status !== 'authenticated') return;

    // Маскируем UUID и другие чувствительные данные в пути
    const maskedPath = maskSensitivePathData(location.pathname);

    // Используем screenView вместо track для корректного отображения в Pages
    screenView(maskedPath, {
      title: document.title,
    });
  }, [location, screenView, status]);

  return null;
}
